// Styles here will override Bulma styles
import { css } from '@emotion/core';
import media from 'css-in-js-media';

export const styledHeaderImage = css`
  .list {
    width: 206px;
    height: 116px;
  }

  img {
    width: 100%;
    max-width: 790px;
    border-radius: 3px;
  }

  ${media('<desktop')} {
    margin: 0 auto;

    .list {
      min-width: 110px;
      min-height: 64px;
      width: 110px;
      height: 64px;
    }
  }
`;
